module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm9 5c.55 0 1 .45 1 1v3c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2h-4c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V9c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v1h4V9c0-.55.45-1 1-1h6zm-9 16c2.913 0 5.462-1.557 6.86-3.884l1.716 1.03C22.826 24.052 19.64 26 16 26c-1.514 0-2.95-.337-4.236-.94l1.036-1.727c.98.43 2.06.668 3.2.668z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./icons/cool.svg
 ** module id = 5
 ** module chunks = 0
 **/